import { render, staticRenderFns } from "./OOServices.vue?vue&type=template&id=3ddabb98&"
import script from "./OOServices.vue?vue&type=script&lang=ts&"
export * from "./OOServices.vue?vue&type=script&lang=ts&"
import style0 from "./OOServices.vue?vue&type=style&index=0&id=3ddabb98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports